module.exports = __webpack_public_path__ + "static/media/Oct24-F18.c87431d5.png";